var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.157,
    height: 24.157,
    viewBox: "0 0 24.157 24.157",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy",
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40543",
    "data-name": "Group 40543",
    transform: "translate(0 4.314)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40542",
    "data-name": "Group 40542"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83897",
    "data-name": "Path 83897",
    d: "M17.255,85.333H2.588A2.588,2.588,0,0,0,0,87.921v14.667a2.588,2.588,0,0,0,2.588,2.588H17.255a2.588,2.588,0,0,0,2.588-2.588V87.921A2.588,2.588,0,0,0,17.255,85.333Z",
    transform: "translate(0 -85.333)",
    fill: "#979797"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40545",
    "data-name": "Group 40545",
    transform: "translate(3.451 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40544",
    "data-name": "Group 40544",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83898",
    "data-name": "Path 83898",
    d: "M86.385,0H70.855a2.588,2.588,0,0,0-2.588,2.568v.02h13.8A4.319,4.319,0,0,1,86.385,6.9v13.8h.02a2.588,2.588,0,0,0,2.568-2.588V2.588A2.588,2.588,0,0,0,86.385,0Z",
    transform: "translate(-68.267 0)",
    fill: "#979797"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.d592f11011005cb87dfff04fdee3f1db.svg";
export { ForwardRef as ReactComponent };